import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const QuickContact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', service: '', message: '' });
  const { t, i18n } = useTranslation('common');
  const lng = (i18n.language || 'en').split('-')[0];
  const map = {
    title: { ar: 'اتصل بنا', ur: 'ہم سے رابطہ کریں', en: 'Contact Us', fr: 'Contactez-nous', de: 'Kontakt', es: 'Contáctanos', pt: 'Fale Conosco', ja: 'お問い合わせ', hi: 'संपर्क करें', it: 'Contattaci', ru: 'Свяжитесь с нами', zh: '联系我们' },
    name: { ar: 'الاسم', ur: 'نام', en: 'Name', fr: 'Nom', de: 'Name', es: 'Nombre', pt: 'Nome', ja: 'お名前', hi: 'नाम', it: 'Nome', ru: 'Имя', zh: '姓名' },
    email: { ar: 'البريد الإلكتروني', ur: 'ای میل', en: 'Email', fr: 'E-mail', de: 'E-Mail', es: 'Correo electrónico', pt: 'E-mail', ja: 'メール', hi: 'ईमेल', it: 'Email', ru: 'Эл. почта', zh: '邮箱' },
    phone: { ar: 'الهاتف', ur: 'فون', en: 'Phone', fr: 'Téléphone', de: 'Telefon', es: 'Teléfono', pt: 'Telefone', ja: '電話番号', hi: 'फ़ोन', it: 'Telefono', ru: 'Телефон', zh: '电话' },
    service: { ar: 'الخدمة', ur: 'سروس', en: 'Service', fr: 'Service', de: 'Service', es: 'Servicio', pt: 'Serviço', ja: 'サービス', hi: 'सेवा', it: 'Servizio', ru: 'Услуга', zh: '服务' },
    message: { ar: 'الرسالة', ur: 'پیغام', en: 'Message', fr: 'Message', de: 'Nachricht', es: 'Mensaje', pt: 'Mensagem', ja: 'メッセージ', hi: 'संदेश', it: 'Messaggio', ru: 'Сообщение', zh: '留言' },
    send: { ar: 'إرسال', ur: 'بھیجیں', en: 'SEND', fr: 'ENVOYER', de: 'SENDEN', es: 'ENVIAR', pt: 'ENVIAR', ja: '送信', hi: 'भेजें', it: 'INVIA', ru: 'ОТПРАВИТЬ', zh: '发送' },
    options: {
      gameDev: { ar: 'تطوير الألعاب', ur: 'گیم ڈویلپمنٹ', en: 'Game Development', fr: 'Développement de jeux', de: 'Spieleentwicklung', es: 'Desarrollo de juegos', pt: 'Desenvolvimento de jogos', ja: 'ゲーム開発', hi: 'गेम विकास', it: 'Sviluppo di giochi', ru: 'Разработка игр', zh: '游戏开发' },
      character: { ar: 'تصميم الشخصيات', ur: 'کریکٹر ڈیزائن', en: 'Character Design', fr: 'Conception de personnages', de: 'Charakterdesign', es: 'Diseño de personajes', pt: 'Design de personagens', ja: 'キャラクターデザイン', hi: 'कैरक्टर डिजाइन', it: 'Character design', ru: 'Дизайн персонажей', zh: '角色设计' },
      animation: { ar: 'الرسوم المتحركة', ur: 'اینیمیشن', en: 'Animation', fr: 'Animation', de: 'Animation', es: 'Animación', pt: 'Animação', ja: 'アニメーション', hi: 'एनीमेशन', it: 'Animazione', ru: 'Анимация', zh: '动画' },
      consultation: { ar: 'استشارة', ur: 'مشاورت', en: 'Consultation', fr: 'Consultation', de: 'Consultation', es: 'Consultoría', pt: 'Consulta', ja: 'コンサルティング', hi: 'परामर्श', it: 'Consulenza', ru: 'Консультация', zh: '咨询' }
    }
  };
  const tv = (key, fallback) => i18n.getResource(lng, 'common', key) || fallback;
  const title = tv('contact.form.title', map.title[lng]);
  const namePh = tv('contact.form.name', map.name[lng]);
  const emailPh = tv('contact.form.email', map.email[lng]);
  const phonePh = tv('contact.form.phone', map.phone[lng]);
  const servicePh = tv('contact.form.service', map.service[lng]);
  const messagePh = tv('contact.form.message', map.message[lng]);
  const sendLbl = tv('contact.form.send', map.send[lng]);
  const optGame = tv('contact.form.options.gameDev', map.options.gameDev[lng]);
  const optChar = tv('contact.form.options.character', map.options.character[lng]);
  const optAnim = tv('contact.form.options.animation', map.options.animation[lng]);
  const optCons = tv('contact.form.options.consultation', map.options.consultation[lng]);

  return (
    <section className="relative pt-8 pb-20 overflow-hidden bg-cream">
      <div className="container mx-auto px-4 py-5 relative z-[1]">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-text-dark mb-2">{title}</h2>
        </div>
        <div className="max-w-[800px] mx-auto">
          <form className="bg-transparent py-10 px-5 md:py-[40px] md:px-5 sm:py-[25px] sm:px-[15px]">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 -mx-2.5">
              <div className="px-2.5">
                <div className="mb-5">
                  <input
                    type="text"
                    name="name"
                    placeholder={namePh}
                    required
                    className="w-full bg-white text-[#191717] font-poppins font-normal border-none rounded-[10px] py-3 px-4 text-base sm:text-sm shadow-[0_4px_12px_rgba(0,0,0,0.1)] transition-all duration-300 hover:shadow-[0_6px_18px_rgba(0,0,0,0.15)] hover:-translate-y-0.5 hover:border-2 hover:border-[rgba(237,201,0,0.3)] focus:outline-none focus:shadow-[0_6px_20px_rgba(237,201,0,0.3)] focus:-translate-y-0.5 focus:border-2 focus:border-[rgba(237,201,0,0.5)] placeholder:text-[#666666]"
                  />
                </div>
                <div className="mb-5">
                  <input
                    type="email"
                    name="email"
                    placeholder={emailPh}
                    required
                    className="w-full bg-white text-[#191717] font-poppins font-normal border-none rounded-[10px] py-3 px-4 text-base sm:text-sm shadow-[0_4px_12px_rgba(0,0,0,0.1)] transition-all duration-300 hover:shadow-[0_6px_18px_rgba(0,0,0,0.15)] hover:-translate-y-0.5 hover:border-2 hover:border-[rgba(237,201,0,0.3)] focus:outline-none focus:shadow-[0_6px_20px_rgba(237,201,0,0.3)] focus:-translate-y-0.5 focus:border-2 focus:border-[rgba(237,201,0,0.5)] placeholder:text-[#666666]"
                  />
                </div>
                <div className="mb-5">
                  <input
                    type="tel"
                    name="phone"
                    placeholder={phonePh}
                    required
                    className="w-full bg-white text-[#191717] font-poppins font-normal border-none rounded-[10px] py-3 px-4 text-base sm:text-sm shadow-[0_4px_12px_rgba(0,0,0,0.1)] transition-all duration-300 hover:shadow-[0_6px_18px_rgba(0,0,0,0.15)] hover:-translate-y-0.5 hover:border-2 hover:border-[rgba(237,201,0,0.3)] focus:outline-none focus:shadow-[0_6px_20px_rgba(237,201,0,0.3)] focus:-translate-y-0.5 focus:border-2 focus:border-[rgba(237,201,0,0.5)] placeholder:text-[#666666]"
                  />
                </div>
              </div>
              <div className="px-2.5">
                <div className="mb-5">
                  <select
                    name="service"
                    required
                    className="w-full bg-white text-[#191717] font-poppins font-normal border-none rounded-[10px] py-3 px-4 text-base sm:text-sm shadow-[0_4px_12px_rgba(0,0,0,0.1)] transition-all duration-300 hover:shadow-[0_6px_18px_rgba(0,0,0,0.15)] hover:-translate-y-0.5 hover:border-2 hover:border-[rgba(237,201,0,0.3)] focus:outline-none focus:shadow-[0_6px_20px_rgba(237,201,0,0.3)] focus:-translate-y-0.5 focus:border-2 focus:border-[rgba(237,201,0,0.5)]"
                  >
                    <option value="">{servicePh}</option>
                    <option value="game-development">{optGame}</option>
                    <option value="character-design">{optChar}</option>
                    <option value="animation">{optAnim}</option>
                    <option value="consultation">{optCons}</option>
                  </select>
                </div>
                <div className="mb-5">
                  <textarea
                    name="message"
                    placeholder={messagePh}
                    rows={4}
                    required
                    className="w-full bg-white text-[#191717] font-poppins font-normal border-none rounded-[10px] py-3 px-4 text-base sm:text-sm shadow-[0_4px_12px_rgba(0,0,0,0.1)] transition-all duration-300 hover:shadow-[0_6px_18px_rgba(0,0,0,0.15)] hover:-translate-y-0.5 hover:border-2 hover:border-[rgba(237,201,0,0.3)] focus:outline-none focus:shadow-[0_6px_20px_rgba(237,201,0,0.3)] focus:-translate-y-0.5 focus:border-2 focus:border-[rgba(237,201,0,0.5)] placeholder:text-[#666666] resize-y min-h-[120px]"
                  />
                </div>
              </div>
            </div>
            <div className="text-center mt-4">
              <button
                type="submit"
                className="bg-brown hover:bg-brown-dark text-cream font-poppins font-medium border-none rounded-[30px] py-3 px-10 text-base tracking-[0.5px] transition-all duration-300 shadow-[0_6px_18px_rgba(0,0,0,0.15)] hover:-translate-y-0.5 hover:shadow-[0_8px_25px_rgba(0,0,0,0.2)] active:translate-y-0"
              >
                {sendLbl}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default QuickContact;
